import { createStore } from "jotai";

import { orderToAssignAtom } from "./atoms/orderToAssign";
import { selectedClientServiceIdAtom } from "./atoms/selectedClientServiceId";
import { selectedOrganisationIdAtom } from "./atoms/selectedOrganisationId";
import { userAtom } from "./atoms/user";

const store: ReturnType<typeof createStore> = createStore();

store.sub(selectedOrganisationIdAtom, () => {
  store.set(orderToAssignAtom, undefined);
});

store.sub(selectedClientServiceIdAtom, () => {
  const selectedService = store
    .get(userAtom)
    ?.Services.find(
      (service) => service.id === store.get(selectedClientServiceIdAtom)
    );

  store.set(selectedOrganisationIdAtom, selectedService?.organisationId || 0);

  store.set(orderToAssignAtom, undefined);
});

store.sub(userAtom, () => {
  store.set(
    selectedOrganisationIdAtom,
    store
      .get(userAtom)
      ?.Services.find(
        (service) => service.id === store.get(selectedClientServiceIdAtom)
      )?.organisationId || 0
  );
});

export { store };
